export default __webpack_public_path__ + "static/facade-sun-33be9104b53a416bbafc5ab1a9ba5301.svg";